import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getLayerTempFilterId } from "../../ducks/layerTempFilter/selectors";
import { setLayerTempFilterId } from "../../ducks/layerTempFilter/layerTempFilter";

export const useTempFilter = (): [string, (id?: string) => void] => {
  const dispatch = useDispatch();
  const tempFilterId = useSelector(getLayerTempFilterId);

  const setTempFilterId = useCallback(
    (id?: string) => {
      dispatch(setLayerTempFilterId(id));
    },
    [dispatch],
  );

  return [tempFilterId, setTempFilterId];
};
